import React from 'react';
import { useParams } from 'react-router-dom';
import FlowsTab from '../tabs/FlowsTab';

export default function FlowDetailPage(): React.ReactElement {
  const { flowId } = useParams();
  return <FlowsTab flowId={String(flowId || '')} hideList showBackToList />;
}

